import { useEffect } from "react"
import { Cookies } from "react-cookie"
import { getUser } from "../service/service"
import { history } from '../router/route';
import { UrlParams } from "../utils/UrlParams"

export const Authen=(props)=>{
    const cookies = new Cookies()
    const params = new UrlParams(props.location.search);
    const code = params.get('code')

    useEffect(()=>{
        cookies.set('user', decodeURI(code))
        getU()
    })

    const getU=()=>{
        getUser().then(result => {
          if (result.code === 200) {
            cookies.set('profile', result.result)
            history.push({
              pathname:'/',
              search:'',
            })
            //history.go(0)
          }else if (result.code === 401) {
            localStorage.removeItem('user')
            localStorage.removeItem('profile')
            history.push('/')
            history.go(0)
          } else {
            // Swal.fire({
            //   icon: 'error',
            //   title: 'Sorry...',
            //   text: 'User not found!'
            // }).then((result)=>{
            //   localStorage.removeItem('user')
            //   localStorage.removeItem('profile')
            //   history.push('/')
            //   history.go(0)
            // })
          }
        }).catch(err => {
          // Swal.fire({
          //   icon: 'error',
          //   title: 'Sorry...',
          //   text: 'User not found!'
          // }).then((result)=>{
          //   history.push('/')
          //   history.go(0)
          // })
        })
      }

    return (
        <>

        </>
    )
}